<template>
  <div>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md6>
          <v-card class="elevation-12">
            <v-toolbar dark color="primary">
              <v-toolbar-title>Вход в систему</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-form>
                <v-text-field
                  prepend-icon="mdi-account"
                  name="username"
                  label="Логин"
                  type="text"
                  v-model="username"
                  @keyup.enter="login"
                >
                </v-text-field>
                <v-text-field
                  prepend-icon="mdi-lock"
                  name="password"
                  label="Пароль"
                  type="password"
                  v-model="password"
                  @keyup.enter="login"
                >
                </v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                @click="login"
                :loading="listLoading.includes('login')"
                :disabled="listLoading.includes('login')"
              >Вход</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
  <!--<div v-else>-->
    <!--<v-container>-->
      <!--<v-layout row>-->
        <!--<v-flex xs12 class="text-xs-center pt-5">-->
          <!--<v-progress-circular-->
            <!--indeterminate-->
            <!--:sice="100"-->
            <!--:widt="4"-->
            <!--color="purple"-->
          <!--&gt;-->
          <!--</v-progress-circular>-->
        <!--</v-flex>-->
      <!--</v-layout>-->
    <!--</v-container>-->
  <!--</div>-->
</template>

<script>
export default {
  data () {
    return {
      username: '',
      password: ''
    }
  },
  computed: {
    listLoading () {
      return this.$store.getters['common/listLoading']
    },
    isAuthenticated () {
      return this.$store.getters['auth/isAuthenticated']
    },
    groupSchool () {
      return this.$store.getters['auth/groupSchool']
    }
  },
  methods: {
    login () {
      const user = {
        username: this.username,
        password: this.password
      }
      this.$store.dispatch('common/clearError')
      this.$store.dispatch('common/pushLoading', 'login')
      this.$store.dispatch('auth/login', user)
        .then(d => {
          this.$store.commit('auth/setToken', d.data.key)
        })
        .then(() => {
          this.$store.dispatch('auth/user').then(() => {
            if (this.$route.query['redirect']) {
              this.$router.push(this.$route.query['redirect'])
            } else {
              if (this.groupSchool) {
                this.$router.push({ name: 'schoolFood' })
              } else {
                this.$router.push({ name: 'home' })
              }
            }
          })
        })
        .catch(error => {
          this.$store.dispatch('common/setError', error)
        })
        .finally(() => {
          this.$store.dispatch('common/popLoading', 'login')
        })
    }
  }
}
</script>
